import { createReducer, on } from '@ngrx/store';
import { ExpenseActions } from './expense.actions';
import { Expense, ExpensesType } from '@core/interface/expense';

export const ExpenseFeatureKey = 'expense';

export interface ExpenseState {
  isLoading: boolean;
  loadError?: any;
  addEditError?: any;
  loadExpenseError?: any;
  expenses: Expense[];
  expenseTypes: ExpensesType[];
  approved?: boolean;
  isCommentLoading?: boolean;
  isClosed: number | null;
}

export const initialState: ExpenseState = {
  isLoading: false,
  expenses: [],
  expenseTypes: [],
  isCommentLoading: false,
  isClosed: null,
};

export const ExpenseReducer = createReducer(
  initialState,
  on(ExpenseActions.loadExpenses, (state) => ({ ...state })),
  on(ExpenseActions.loadExpensesSuccess, (state, response) => ({
    ...state,
    expenses: response.data,
    isDeleted: false,
    loadExpenseError: null,
    isClosed: response.is_closed,
  })),
  on(ExpenseActions.loadExpensesFailure, (state, { error }) => {
    return {
      ...state,
      loadExpenseError: error,
      isDeleted: false,
      isClosed: null,
    };
  }),
  on(ExpenseActions.loadExpensesTypes, (state) => ({ ...state })),
  on(ExpenseActions.loadExpensesTypesSuccess, (state, { data }) => ({
    ...state,
    expenseTypes: data,
    isDeleted: false,
    loadExpenseTypeError: null,
  })),
  on(ExpenseActions.loadExpensesTypesFailure, (state, { error }) => {
    return {
      ...state,
      loadExpenseTypeError: error,
      isDeleted: false,
    };
  }),
  on(ExpenseActions.approveExpenses, (state) => ({
    ...state,
    approved: false,
  })),
  on(ExpenseActions.approveExpensesSuccess, (state, data) => ({
    ...state,
    isDeleted: false,
    approvalError: null,
    approved: data.success,
  })),
  on(ExpenseActions.approveExpensesFailure, (state, { error }) => {
    return {
      ...state,
      approvalError: error,
      isDeleted: false,
      approved: false,
    };
  }),
  on(ExpenseActions.resetApproveExpenses, (state) => ({
    ...state,
    approved: false,
  })),

  on(ExpenseActions.editExpense, (state) => ({
    ...state,
    isUpdated: false,
  })),
  on(ExpenseActions.editExpenseSuccess, (state, { data }) => ({
    ...state,
    expenses: state.expenses.map((expense) =>
      data.id == expense.id ? data : expense
    ),
    isUpdated: true,
  })),
  on(ExpenseActions.editExpenseFailure, (state) => ({
    ...state,
    isUpdated: false,
  })),

  on(ExpenseActions.addComment, (state) => ({
    ...state,
    isCommentLoading: false,
  })),
  on(ExpenseActions.addCommentSuccess, (state, { data }) => ({
    ...state,
    expenses: state.expenses.map((expense) =>
      data.id == expense?.id ? data : expense
    ),
    isCommentLoading: true,
  })),
  on(ExpenseActions.addCommentFailure, (state) => ({
    ...state,
    isCommentLoading: false,
  })),
  on(ExpenseActions.adminDirectApprove, (state) => ({
    ...state,
    approved: false,
  })),
  on(ExpenseActions.adminDirectApproveSuccess, (state, data) => ({
    ...state,
    approved: data.success,
  })),
  on(ExpenseActions.adminDirectApproveFailure, (state, { error }) => ({
    ...state,
    approved: false,
    approvalError: error,
  }))
);
